import React, { useContext, useMemo } from 'react'
import { FiFileText, FiCheckCircle, FiMail } from 'react-icons/fi'
import LogoClicksign from '@resources/imgs/logo-empresa.png'
import { formatOrderDate } from '../../utils/formatOrderDate'
import './ContractStatus.css'
import AuthContext from '@contexts/Auth'

interface PendingContractStatusProps {
  internal_id: string
  sent_at?: Date | null
  signing_url?: string | null
  has_patient_signed: boolean
  signed_count: number
  total_signers: number
  contract_holder?: string
  full_donor?: string
}

const PendingContractStatus: React.FC<PendingContractStatusProps> = ({
  internal_id,
  sent_at,
  signing_url,
  has_patient_signed,
  signed_count,
  total_signers,
  contract_holder,
  full_donor
}) => {
  const { user } = useContext(AuthContext)

  const contractHolderName = useMemo(() => {
    const contractHolder = contract_holder ?? 'patient'
    if (contractHolder === 'partner' && user?.patient.partner_name) {
      return user.patient.partner_name
    }
    return user?.name || ''
  }, [contract_holder, user])

  return (
    <div className="contract-status-container-pending">
      {/* Header Section */}
      <div className="contract-header-section">
        <div className="d-flex align-items-center gap-3">
          <div className="clicksign-logo-header">
            <img src={LogoClicksign} alt="Clicksign" />
          </div>
        </div>
        <div className="status-badge-pending">
          <span className="status-dot"></span>
          Aguardando
        </div>
      </div>

      {/* Info Boxes Section */}
      <div className="contract-info-boxes">
        <div className="info-box">
          <p className="info-label">Data de envio</p>
          <p className="info-value mb-0">{formatOrderDate(sent_at ?? undefined)}</p>
        </div>
        <div className="info-box">
          <p className="info-label">Contrato</p>
          <p className="info-value mb-1">{`Pedido nº ${internal_id} - ${contractHolderName} - Doador ${full_donor}.docx`}</p>
        </div>
      </div>

      {/* Content Section */}
      <div className="contract-content-section">
        {has_patient_signed ? (
          <>
            <div className="signed-confirmation-box">
              <FiCheckCircle className="text-success" size={24} />
              <div>
                <p className="mb-2"><strong>Você já assinou o contrato!</strong></p>
                <p className="text-muted mb-2">
                  Assinaturas concluídas: <strong>{signed_count} de {total_signers}</strong>
                </p>
                <p className="text-muted mb-0">
                  Aguardando as demais assinaturas para finalizar o contrato.<br />
                  Quando todos assinarem, você poderá baixa-lo.
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Warning Alert */}
            <div className="contract-warning-alert">
              <div className="warning-icon-box">
                <FiMail size={24} />
              </div>
              <p className="warning-text mb-0">
                Verifique seu e-mail e caixa de SPAM. Assine <strong>antes</strong> do envio da amostra de sêmen.
              </p>
            </div>

            {/* Sign Button */}
            {signing_url && (
              <a
                href={signing_url}
                target="_blank"
                rel="noopener noreferrer"
                className="contract-sign-button"
              >
                <FiFileText size={22} />
                Assinar Contrato Agora
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default PendingContractStatus
